module.exports = __webpack_public_path__ + "static/media/krype.2aea202c.m4a";